import React from 'react';

import { Inline, Text } from '@atlaskit/primitives/compiled';

import type { PreviewPanelTitleProps } from './types';

export const PreviewPanelTitle = ({
	title,
	icon,
	color,
}: PreviewPanelTitleProps): React.JSX.Element => {
	return (
		<Inline space="space.100" alignBlock="center">
			{icon}
			<Text weight="bold" maxLines={1} color={color}>
				{title}
			</Text>
		</Inline>
	);
};
